/**
 * =========================================================================================
 * Test ID Constants for Account Module
 * =========================================================================================
 */

export const TEST_ID = {
    // ===========================
    // Authentication Module
    // ===========================

    LOGIN: {
        EMAIL_INPUT: 'login.email.input',
        IDENTIFIER_INPUT: 'login.identifier.input',
        PASSWORD_INPUT: 'login.password.input',
        EMAIL_WRAPPER: 'login.email.wrapper',
        PASSWORD_WRAPPER: 'login.password.wrapper',
        SUBMIT_BUTTON: 'login.submit.button',
        MICROSOFT_BUTTON: 'login.microsoft.button',
        MICROSOFT_ICON: 'login.microsoft.icon',
        FORGOT_PASSWORD_LINK: 'login.forgotPassword.link',
        ERROR_MESSAGE: 'login.error.message',
        PASSWORD_TOGGLE: 'login.password.toggle',
    },

    REGISTRATION: {
        FIRST_NAME_INPUT: 'registration.firstname.input',
        LAST_NAME_INPUT: 'registration.lastname.input',
        EMAIL_INPUT: 'registration.email.input',
        COMPANY_NAME_INPUT: 'registration.companyname.input',
        COMPANY_INPUT: 'registration.company.input',
        INDUSTRY_TYPE_INPUT: 'registration.industrytype.input',
        REFERRAL_INPUT: 'registration.referral.input',
        INPUT_WRAPPER: 'registration.input.input',
        LINK: 'registration.link.link',
        SUBMIT_BUTTON: 'registration.button',
    },

    REGISTER_INVITE: {
        FIRST_NAME_INPUT: 'registerinivite.firstname.input',
        LAST_NAME_INPUT: 'registerinivite.lastname.input',
        EMAIL_INPUT: 'registerinivite.email.input',
        PASSWORD_INPUT: 'registerinivite.password.input',
        INPUT_WRAPPER: 'registerinivite.input.input',
        BUTTON: 'registerinivite.button',
    },

    INVITATION_REGISTER: {
        FIRST_NAME_INPUT: 'invitation-register.firstname.input',
        LAST_NAME_INPUT: 'invitation-register.lastname.input',
        EMAIL_INPUT: 'invitation-register.email.input',
        PASSWORD_INPUT: 'invitation-register.password.input',
        CONFIRM_PASSWORD_INPUT: 'invitation-register.cpassword.input',
        INPUT_WRAPPER: 'invitation-register.input.input',
        LINK: 'invitation-register.link.link',
        CHECKBOX: 'invitation-register.ucheckbox',
        BUTTON: 'invitation-register.button',
        PASSWORD_TOGGLE: 'invitation-register.password.toggle',
    },

    FORGOT_PASSWORD: {
        EMAIL_INPUT: 'forgotpassword.email.input',
        FORGOT_PASSWORD_EMAIL_INPUT: 'forgot-password.email.input',
        INPUT_WRAPPER: 'forgotpassword.input.input',
        SUBMIT_BUTTON: 'forgotpassword.button',
        FORGOT_PASSWORD_SUBMIT_BUTTON: 'forgot-password.button',
        FORGOT_PASSWORD_INPUT_WRAPPER: 'forgot-password.input.input',
        RESEND_OTP_LINK: 'forgot-password.resendOtp.link',
        RECOVERY_CODE_LINK: 'forgot-password.recoveryCode.link',
    },

    FORGET_WITH_RECOVERY: {
        IDENTIFIER_INPUT: 'forget-with-recovery.identifier.input',
        RECOVERY_CODE_INPUT: 'forget-with-recovery.recoverycode.input',
        INPUT_WRAPPER: 'forget-with-recovery.input.input',
        BUTTON: 'forget-with-recovery.button',
    },

    RESET_PASSWORD: {
        PASSWORD_INPUT: 'resetpassword.password.input',
        CONFIRM_PASSWORD_INPUT: 'resetpassword.cpassword.input',
        PASSWORD_WRAPPER: 'resetpassword.input.input',
        CANCEL_BUTTON: 'resetpassword.cancel.button',
        CHANGE_PASSWORD_BUTTON: 'resetpassword.changePassword.button',
        RESET_PASSWORD_BUTTON: 'resetpassword.resetPassword.button',
        SIGN_IN_BUTTON: 'resetpassword.signIn.button',
        PASSWORD_TOGGLE: 'resetpassword.password.toggle',
    },

    RESET_PASSWORD_ONBOARDING: {
        PASSWORD_INPUT: 'reset-password.password.input',
        CONFIRM_PASSWORD_INPUT: 'reset-password.cpassword.input',
        INPUT_WRAPPER: 'reset-password.input.input',
        CANCEL_BUTTON: 'reset-password.cancel.button',
        CHANGE_PASSWORD_BUTTON: 'reset-password.changePassword.button',
        SIGN_IN_BUTTON: 'reset-password.signIn.button',
        PASSWORD_TOGGLE: 'reset-password.password.toggle',
    },

    CHANGE_FIRST_PASSWORD: {
        EMAIL_INPUT: 'change-first-password.email.input',
        EMPLOYEE_CODE_INPUT: 'change-first-password.employee code.input',
        OLD_PASSWORD_INPUT: 'change-first-password.oldpassword.input',
        NEW_PASSWORD_INPUT: 'change-first-password.newpassword.input',
        CONFIRM_PASSWORD_INPUT: 'change-first-password.cpassword.input',
        INPUT_WRAPPER: 'change-first-password.input.input',
        CANCEL_BUTTON: 'change-first-password.button',
        CHANGE_PASSWORD_BUTTON: 'change-first-password.button',
        PASSWORD_TOGGLE: 'change-first-password.password.toggle',
    },

    VERIFY_EMAIL: {
        SUBMIT_BUTTON: 'verifyemail.button',
        RESEND_OTP_LINK: 'verify-email.resendOtp.link',
        CHANGE_EMAIL_LINK: 'verify-email.changeEmail.link',
    },

    MFA: {
        CODE_INPUT: 'multi-factor-authenticate.input',
        RADIO: 'multi-factor-authenticate.uradio',
        SEND_OTP_BUTTON: 'multi-factor-authenticate.button',
        VERIFY_BUTTON: 'multi-factor-authenticate.button',
        RESEND_OTP_LINK: 'multi-factor-authenticate.resendOtp.link',
        RECOVERY_CODE_LINK: 'multi-factor-authenticate.recoveryCode.link',
    },

    SETUP_MFA: {
        VERIFY_BUTTON: 'setup-multi-factor.button',
        CANCEL_BUTTON: 'setup-multi-factor.button',
        SAVE_BUTTON: 'setup-multi-factor.button',
        MODAL: 'setup-multi-factor.modal',
        CHECKBOX: 'setup-multi-factor.ucheckbox',
        QR_CODE_MODAL_LINK: 'setup-multi-factor.qrCodeModal.link',
        COPY_RECOVERY_CODE_ICON: 'setup-multi-factor.copyRecoveryCode.icon',
        COPY_SECRET_KEY_ICON: 'setup-multi-factor.copySecretKey.icon',
        GENERATE_QR_CODE_BUTTON: 'setup-multi-factor.generateQrCode.button',
    },

    TWO_FA_RECOVERY: {
        RECOVERY_CODE_INPUT: '2fa-recovery-code.recoverycode.input',
        INPUT_WRAPPER: '2fa-recovery-code.input.input',
        SAVE_BUTTON: '2fa-recovery-code.button',
    },

    WORKSPACE: {
        RELOAD_BUTTON: 'workspace.reload.button',
        LOGOUT_BUTTON: 'workspace.logout.button',
        NEXT_BUTTON: 'workspace.next.button',
        UPDATE_MFA_LINK: 'workspace.updateMfa.link',
        ORG_LIST_ITEM: 'workspace.orgListItem.li',
        HRMS_MODULE: 'workspace.hrms.module',
        CHAT_MODULE: 'workspace.chat.module',
        PMS_MODULE: 'workspace.pms.module',
        PAYROLL_MODULE: 'workspace.payroll.module',
        SURVEY_MODULE: 'workspace.survey.module',
        RECRUIT_MODULE: 'workspace.recruit.module',
        ASSETS_MODULE: 'workspace.assets.module',
        PERFORMANCE_MODULE: 'workspace.performance.module',
        TRACK_MODULE: 'workspace.track.module',
        VMS_MODULE: 'workspace.vms.module',
    },

    STAY_TUNED: {
        HOME_BUTTON: 'stay-tuned.home.button',
        SCHEDULE_DEMO_BUTTON: 'stay-tuned.scheduleDemo.button',
    },

    EMAIL_SENT: {
        LOGIN_BUTTON: 'emailsent.button',
        EMAIL_SENT_BUTTON: 'email-sent.button',
    },

    VERIFY_ORGANIZATION: {
        SUBMIT_BUTTON: 'verifyorganization.button',
    },

    VERIFY_OTP: {
        VERIFY_BUTTON: 'verify-otp.button',
        RESEND_OTP_LINK: 'verify-otp.resendOtp.link',
        CHANGE_EMAIL_LINK: 'verify-otp.changeEmail.link',
    },

    AUTHORIZE: {
        IDENTIFIER_INPUT: 'authorize.identifier.input',
        PASSWORD_INPUT: 'authorize.password.input',
        INPUT_WRAPPER: 'authorize.input.input',
        BUTTON: 'authorize.button',
        PASSWORD_TOGGLE: 'authorize.password.toggle',
        RESEND_OTP_LINK: 'authorize.resendOtp.link',
    },

    INVITE_CLIENT: {
        BUTTON: 'invite-client.button',
    },

    // ===========================
    // On-boarding Module
    // ===========================

    ONBOARDING_LOGIN: {
        EMAIL_INPUT: 'login.email.input',
        PASSWORD_INPUT: 'login.password.input',
        EMAIL_WRAPPER: 'login.email.wrapper',
        PASSWORD_WRAPPER: 'login.password.wrapper',
        SUBMIT_BUTTON: 'login.submit.button',
        FORGOT_PASSWORD_LINK: 'login.forgotPassword.link',
    },

    ONBOARDING_REGISTER: {
        EMAIL_INPUT: 'register.email.input',
        PASSWORD_INPUT: 'register.password.input',
        CONFIRM_PASSWORD_INPUT: 'register.cpassword.input',
        INPUT_WRAPPER: 'register.input.input',
        BUTTON: 'register.button',
        PASSWORD_TOGGLE: 'register.password.toggle',
    },

    // ===========================
    // Sign-up Module (v2)
    // ===========================

    SIGNUP_LOGIN: {
        EMAIL_INPUT: 'login.identifier.input',
        PASSWORD_INPUT: 'login.password.input',
        EMAIL_WRAPPER: 'login.email.wrapper',
        PASSWORD_WRAPPER: 'login.password.wrapper',
        SUBMIT_BUTTON: 'login.submit.button',
        MICROSOFT_ICON: 'login.microsoft.icon',
        FORGOT_PASSWORD_LINK: 'login.forgotPassword.link',
    },

    SIGNUP_REGISTRATION: {
        BUTTON: 'registration.button',
    },

    TRACK_REGISTRATION: {
        FIRST_NAME_INPUT: 'track-registration.firstname.input',
        LAST_NAME_INPUT: 'track-registration.lastname.input',
        EMAIL_INPUT: 'track-registration.email.input',
        PASSWORD_INPUT: 'track-registration.password.input',
        CONFIRM_PASSWORD_INPUT: 'track-registration.cpassword.input',
        REFERRAL_INPUT: 'track-registration.referral.input',
        INPUT_WRAPPER: 'track-registration.input.input',
        LINK: 'track-registration.link.link',
        CHECKBOX: 'track-registration.ucheckbox',
        BUTTON: 'track-registration.button',
        PASSWORD_TOGGLE: 'track-registration.password.toggle',
    },

    COMPANY_DETAILS: {
        COMPANY_INPUT: 'company-details.company.input',
        INPUT_WRAPPER: 'company-details.input.input',
        BUTTON: 'company-details.button',
    },

    COMPANY_OTHER_INFO: {
        INPUT: 'company-other-info.input',
        CHECKBOX: 'company-other-info.ucheckbox',
        BUTTON: 'company-other-info.button',
    },

    OPTION_SELECTOR: {
        OTHER_INPUT: 'option-selector.jsx.other.input',
        INPUT_WRAPPER: 'option-selector.jsx.input.input',
        BUTTON: 'option-selector.button',
        OPTION_ITEM: 'option-selector.item',
    },

    BUILDING_ACCOUNT: {
        TEXT: 'building-account.text',
        BUTTON: 'building-account.button',
        SETUP_DONE_BUTTON: 'building-account.setupDone.button',
    },

    // ===========================
    // Common Elements
    // ===========================

    COMMON: {
        CLOSE_BUTTON: 'common.close.button',
        CANCEL_BUTTON: 'common.cancel.button',
        SAVE_BUTTON: 'common.save.button',
        DELETE_BUTTON: 'common.delete.button',
        CONFIRM_BUTTON: 'common.confirm.button',
        SUBMIT_BUTTON: 'common.submit.button',
        MODAL_CONTAINER: 'common.modal.container',
        MODAL_HEADER: 'common.modal.header',
        MODAL_BODY: 'common.modal.body',
        MODAL_FOOTER: 'common.modal.footer',
        SUCCESS_TOAST: 'common.toast.success',
        ERROR_TOAST: 'common.toast.error',
        WARNING_TOAST: 'common.toast.warning',
        INFO_TOAST: 'common.toast.info',
        LOADER: 'common.loader',
        SPINNER: 'common.spinner',
        FORM_ERROR: 'common.form.error',
        FORM_SUCCESS: 'common.form.success',
        RELOAD_BUTTON: 'common.reload.button',
        OPTION_ITEM: 'common.option.item',
        COPY_ICON: 'common.copy.icon',
        BACK_LINK: 'common.back.link',
        LOGIN_REDIRECT_LINK: 'common.loginRedirect.link',
        WORKSPACE_REDIRECT_LINK: 'common.workspaceRedirect.link',
        LOGOUT_BUTTON: 'common.logout.button',
    },
};

export function generateDynamicTestId(baseId, identifier) {
    return `${baseId}.${identifier}`;
}

export function isValidTestId(testId) {
    const pattern = /^[a-z0-9]+(\.[a-z0-9 ]+)+$/i;
    return pattern.test(testId);
}
